import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import type { ReactNode } from "react";
import SxqHiveLogo from "./SxqHiveLogo.tsx";

interface AuthCardProps {
  title: ReactNode;
  /** A grey line under the title. */
  subtitle?: ReactNode;
  children: ReactNode;
}

/**
 * The shell of the pages a signed-out visitor sees (login, SSO MFA, accepting an invitation):
 * an outlined card centred on the screen with the logo, a title and the form.
 */
export default function AuthCard({ title, subtitle, children }: AuthCardProps) {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", py: 4 }}>
      <Container maxWidth="xs">
        <Paper variant="outlined" sx={{ p: 4 }}>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            <SxqHiveLogo variant="auto" height={36} />
          </Box>
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Typography variant="h6" component="h1">
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {children}
        </Paper>
      </Container>
    </Box>
  );
}
